import { render } from "./DiscountDetailsModal.vue?vue&type=template&id=5eb32026&scoped=true"
import script from "./DiscountDetailsModal.vue?vue&type=script&lang=js"
export * from "./DiscountDetailsModal.vue?vue&type=script&lang=js"

import "./DiscountDetailsModal.vue?vue&type=style&index=0&id=5eb32026&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eb32026"]])

export default __exports__